// Module
var code = "<a href ui-sref=\"cart\" ng-class=\"{'cart-approved': dir.items && dir.items.length>0, 'cart-hold': dir.items && dir.items.length>0 && !dir.approved}\"> <span class=\"cart-total d-md-none\" ng-show=\"dir.items && dir.items.length>0\">{{ dir.getQuantity() }}</span> <i class=\"fa fa-shopping-cart\"></i> </a> ";
// Exports
module.exports = code;